  function arrangeColumns(panel) {
    console.log('panel container found');
    var controls = Array.from(panel.querySelectorAll('.globo-form-control'));
    console.log('Number of controls found:', controls.length);
    if (controls.length < 5) {
      console.log('Not enough controls to split into columns');
      return;
    }
    var col1 = document.createElement('div');
    col1.className = 'form-col';
    var col2 = document.createElement('div');
    col2.className = 'form-col';

    // Helper to find a control by label text, ignoring case, dashes, and spaces
    function findControl(labelText) {
      function normalize(s) {
        return s.toLowerCase().replace(/[-\s]/g, '');
      }
      return controls.find(ctrl => {
        var label = ctrl.querySelector('.globo-label, label');
        return label && normalize(label.textContent).includes(normalize(labelText));
      });
    }

    var nameControl = findControl('name');
    var emailControl = findControl('email');
    var contactControl = findControl('contact');
    var subjectControl = findControl('subject');
    var messageControl = findControl('message');

    if (nameControl) col1.appendChild(nameControl);
    if (emailControl) col1.appendChild(emailControl);
    if (contactControl) col1.appendChild(contactControl);
    if (subjectControl) col2.appendChild(subjectControl);
    if (messageControl) {
      messageControl.classList.add('message-control');
      col2.appendChild(messageControl);
    }

    while (panel.firstChild) {
      panel.removeChild(panel.firstChild);
    }
    panel.appendChild(col1);
    panel.appendChild(col2);
    console.log('Columns appended');
  }

  document.addEventListener('DOMContentLoaded', function () {
    console.log('Script loaded');
    var panel = document.querySelector('.pfb-contact-form .panel');
    if (panel) {
      arrangeColumns(panel);
      return;
    }
    // If not found, observe for it
    var observer = new MutationObserver(function(mutations, obs) {
      var panel = document.querySelector('.pfb-contact-form .panel');
      if (panel) {
        arrangeColumns(panel);
        obs.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Hide the Powered by Globo Contact Form text
    var globoCredit = Array.from(document.querySelectorAll('.pfb-contact-form p')).find(
      p => p.textContent.includes('Powered by Globo')
    );
    if (globoCredit) {
      globoCredit.style.display = 'none';
    }
    // Hide the Powered by Globo Contact Form text when it appears
    function hideGloboCredit() {
      var globoCredit = Array.from(document.querySelectorAll('.pfb-contact-form p')).find(
        p => p.textContent.includes('Powered by Globo')
      );
      if (globoCredit) {
        globoCredit.style.display = 'none';
        return true;
      }
      return false;
    }
    if (!hideGloboCredit()) {
      var creditObserver = new MutationObserver(function(mutations, obs) {
        if (hideGloboCredit()) {
          obs.disconnect();
        }
      });
      creditObserver.observe(document.body, { childList: true, subtree: true });
    }

    // Fix subject select: hide first empty option and set dropdown width
    var subjectSelect = document.querySelector('.pfb-contact-form select.classic-input');
    if (subjectSelect) {
      // Hide the first option if it's empty/disabled
      var firstOption = subjectSelect.options[0];
      if (firstOption && firstOption.disabled && !firstOption.value) {
        firstOption.style.display = 'none';
      }
      // Set the select's style to help dropdown width match input
      subjectSelect.style.width = '100%';
      subjectSelect.style.maxWidth = '100%';
      subjectSelect.style.boxSizing = 'border-box';
    }
  });